import { type ChipBadgeColor } from '@/components/ReviewsManagement/Reviews/types'
import { UniversalReviewStates } from '@/gql/reviews'

export const universalReviewStatusFilterOrder: UniversalReviewStates[] = [
  UniversalReviewStates.Published,
  UniversalReviewStates.Drafted,
  UniversalReviewStates.InRevision,
  UniversalReviewStates.Stale,
  UniversalReviewStates.Rejected,
  UniversalReviewStates.Depublished,
  UniversalReviewStates.Proposed,
]

export function universalReviewStatusLabelKey(status: UniversalReviewStates): string {
  return status === UniversalReviewStates.InRevision ? 'reDrafted' : status
}

export function universalReviewStatusColor(status: UniversalReviewStates): ChipBadgeColor {
  switch (status) {
    case UniversalReviewStates.Published:
      return 'mint'
    case UniversalReviewStates.Drafted:
    case UniversalReviewStates.InRevision:
      return 'purple'
    case UniversalReviewStates.Rejected:
    case UniversalReviewStates.Depublished:
      return 'error'
    case UniversalReviewStates.Proposed:
      return 'yellow'
    case UniversalReviewStates.Stale:
      return 'default'
    default:
      return 'default'
  }
}
